// extracted by mini-css-extract-plugin
export var searchHeader = "_af-0";
export var searchHeaderDark = "_af-1";